import dynamic from 'next/dynamic';

import type { TrustBannerSectionProps } from 'src/components/sections/TrustBannerSection/TrustBannerSection';
import type { SectionRenderer } from 'src/types/Section';
import type { Transformer } from 'src/types/Transformer';
import type { TrustBannerSectionContent } from './types';

export const renderer: SectionRenderer<TrustBannerSectionProps> = dynamic<TrustBannerSectionProps>(
  () =>
    import('src/components/sections/TrustBannerSection/TrustBannerSection').then(
      (mod) => mod.TrustBannerSection,
    ),
);

export const transformer: Transformer<TrustBannerSectionContent, TrustBannerSectionProps> = (
  content,
) => {
  const [refContent] = content.trust_content || [];
  const referencedContentMissing = !refContent?.headline || !refContent.cards?.length;

  if (referencedContentMissing) {
    return {
      uid: content._metadata.uid,
      props: {
        cards: [],
        headline: '',
        trackingTitle: content.tracking_title,
      },
      errors: [{ message: 'Referenced trust content is missing.', preventRender: true }],
    };
  }

  const buttonHref = refContent.button_reference?.[0]?.url;

  return {
    uid: content._metadata.uid,
    props: {
      cards: refContent.cards!.map((card) => ({
        image: { alt: card.image?.description || '', src: card.image?.url || '' },
        text: card.text,
      })),
      headline: refContent.headline!,
      ...(refContent.intro_text && { introText: refContent.intro_text }),
      ...(refContent.logo && {
        logo: { alt: refContent.logo.description || '', src: refContent.logo.url },
      }),
      ...(refContent.button_text &&
        buttonHref && { cta: { href: buttonHref, text: refContent.button_text } }),
      trackingTitle: content.tracking_title,
    },
  };
};
